import { GET_TERMINE_KALENDER_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';
import { defaultOhneKalender } from '@/domain/termine/shared/utils/defaultOhneKalender';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  GetTermineKalenderByStandortIdAndZeitraumQuery,
  GetTermineKalenderByStandortIdAndZeitraumQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function useTerminKalenderList(): {
  kalender: TerminKalender[];
  error: Error | null;
} {
  const { currentStandort } = useStandortContext();
  const { t } = useTranslation();
  const today = dayjs().startOf('day');

  const { data, error } = useSuspenseQuery<
    GetTermineKalenderByStandortIdAndZeitraumQuery,
    GetTermineKalenderByStandortIdAndZeitraumQueryVariables
  >(GET_TERMINE_KALENDER_BY_STANDORTID_AND_ZEITRAUM, {
    variables: {
      standortIds: [currentStandort.id],
      zeitraum: {
        von: today.format('YYYY-MM-DD'),
        bis: today.add(5, 'year').format('YYYY-MM-DD'),
      },
    },
    fetchPolicy: 'network-only',
  });

  if (error || !data) {
    return {
      kalender: [],
      error: error ?? new Error('No data'),
    };
  }

  const kalender = (
    data?.termine_termineKalenderByStandortIdAndZeitraum ?? []
  ).map(
    (k) =>
      new TerminKalender({
        id: k.id,
        name: k.name,
        kalenderSchluessel: k.kalenderSchluessel,
        idStandort: k.idStandort,
        markierung: k.markierung,
        termineCount: (k.termine ?? []).filter(
          (t) =>
            dayjs(t.datum).isSame(today, 'day') ||
            dayjs(t.datum).isAfter(today, 'day'),
        ).length,
      }),
  );

  return { kalender: defaultOhneKalender(kalender, t), error };
}
